import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'trimTitlePipe' })

export class TrimTitlePipe implements PipeTransform {

    transform(value: string): string {
        if (!value) return value;

        // Regular expression dynamically handles known titles
        const titlesRegex = /^(Mr\.?|Mrs\.?|Miss\.?|Dr\.?|Prof\.?|Ms\.?|Mx\.?)\s+/i;

        // Use regex to remove the title from the beginning of the string
        return value.replace(titlesRegex, '').trim();
    }

}
